// extracted by mini-css-extract-plugin
export default {"secure-mode":"SecureMode_secure-mode__vaxHf"};